import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import useAuth from '../../context/auth/useAuth'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { cloneSelection, getSelectionsByMultiSchool } from '../../actions/selectionsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { registerChartPlugins } from '../../hooks/ChartJSHook';

export default function Process({finished = false}) {
    const { t } = useTranslation()
	const navigate = useNavigate()
    const {client} = useAuth()
	const dispatch = useDispatch()

    const {selections, resultselection, selectionGoTo} = useSelector(state=>state.selections)

    const [selectionsFilter, setSelectionsFilter] = useState(null)

	registerChartPlugins() // Inicializa los plugins de Chart.js
	const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                  label: function (tooltipItem) {
                    const dataset = tooltipItem.dataset;
                    const currentValue = dataset.data[tooltipItem.dataIndex];
                    const total = dataset.data.reduce((acc, val) => acc + val, 0);
                    const percentage = ((currentValue / total) * 100).toFixed(2); // Calcula el porcentaje
                    return ` ${percentage}%`; // Retorna el texto del tooltip
                  },
                },
            },
            centerText: null
        },
    }

    useEffect(() => {
		if(client){
			dispatch(getSelectionsByMultiSchool(client.id))
		}

	// eslint-disable-next-line
	},[client])

    useEffect(() => {
		if(selections){
			if(finished){
				const finished = selections.filter(selection => selection.finished === true)
				setSelectionsFilter(finished)
			}else{
				const notfinished = selections.filter(selection => selection.finished === false)
				setSelectionsFilter(notfinished)
			}
		}
	},[selections, finished])

	const handleClone = (e, selection) => {
		e.preventDefault()

		Swal.fire({
			showConfirmButton: true,
			showDenyButton: true,
			confirmButtonText: t('global.confirm'),
			denyButtonText: t('global.cancel'),
			icon: 'question',
			text: t('selection.cloneSelectionQuestion')
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(cloneSelection(selection))
			}
		})
	}

	const columnsSelections = [
		{
			name: t('admin.dashboard.name'),
			id: 'id',
			cell: selection =>
				<div>
				{
					selection.started === true
					?
						<Link to={`/multischool/overviewprocess/${selection._id}`} className='mx-2 link-dark'>
							{selection?.title}
						</Link>
					:
						<Link to={`/multischool/editprocess/${selection._id}`} className='mx-2 link-dark'>
							{selection?.title}
						</Link>
				}
				</div>,
			selector: (selection) => selection.title,
			sortable: true,
		},
		{
			name: t('selection.school'),
			cell: selection =>
				<div>
				{
					selection.started === true
					?
						<Link to={`/multischool/overviewprocess/${selection._id}`} className='mx-2 link-dark'>
							{selection?.school?.name}
						</Link>
					:
						<Link to={`/multischool/editprocess/${selection._id}`} className='mx-2 link-dark'>
							{selection?.school?.name}
						</Link>
				}
				</div>,
			selector: (selection) => selection?.school?.name,
			sortable: true,
		},{
			name: t('selection.candidatesprecandidates'),
			center: 'center',
			width: "180px",
			cell: selection =>
				<div>
					{selection.precandidatesCount ? selection?.chosenCount + ' / ' + selection?.precandidatesCount : ''}
                </div>,
			selector: (selection) => selection.precandidatesCount
        },{
			name: t('selection.startDateTable'),
			center: 'center',
			width: "180px",
			cell: ({ startDate }) => {
                const formattedDate = new Date(startDate).toLocaleDateString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                })
                return <div><span className='d-none'>{startDate}</span>{formattedDate}</div>
            },
			selector: (selection) => selection.startDate,
			sortable: true,
        },{
            name: t('global.status'),
            center: 'center',
			width: "150px",
			cell: selection =>
                <div>
                {selection.published
                    ?
                        <div className='pildora published'>{t('global.published')}</div>
                    :
                        <div className='pildora draft'>{t('global.draft')}</div>
                }
                </div>
		},{
			name: t('global.actions'),
			center: 'center',
			width: "120px",
			cell: selection =>
				<div>

					{
						selection.started === true
						?
							<Link to={`/multischool/overviewprocess/${selection._id}`} className='mx-2 link'>
								<i className='fas fa-eye'></i>
							</Link>
						:
							<Link to={`/multischool/editprocess/${selection._id}`} className='mx-2 link'>
								<i className='fas fa-edit'></i>
							</Link>
					}
					<a href="#" onClick={(e) => handleClone(e, selection._id)} className='mx-2 link'>
						<img src="/images/clone.svg" alt="Clone" className="ms-2"/>
					</a>
				</div>
		}
	]

	const ExpandedRow = ({ data }) => {
		const videoSawPercent = ((data?.videoSawCount || 0) / (data?.uploadedVideoCount || 0)) * 100
		const videoNoSawPercent = 100 - videoSawPercent
		const interviewsDonePercent = ((data?.interviewsDoneCount || 0) / ((data?.interviewsPendingCount || 0) + (data?.interviewsDoneCount || 0))) * 100
		const interviewsPendingPercentage = 100 - interviewsDonePercent
        return (
			data.precandidatesCount > 0 &&
            <Container className='p-3 previewData'>
                <Row className='my-3 py-2'>
					{data.videoPresentation &&
						<Col xs={12} md={4}>
							<Card>
								<Card.Body>
									<div className='d-flex align-items-center'>
										<div className='chartPreviewData'>
											<Doughnut
												data={{
													labels: [
														`${t('selection.videoSaw')} (${videoSawPercent.toFixed(1)}%)`,
														`${t('selection.videoNoSaw')} (${videoNoSawPercent.toFixed(1)}%)`,
													],
													datasets: [
														{
															data: [
																data?.videoSawCount || 0,
																(data?.uploadedVideoCount || 0) - (data?.videoSawCount || 0),
															],
															backgroundColor: ['#89CF2B', '#DEF3BE'],
															hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
														},
													],
												}}
												options={options}
											/>
										</div>
										<div className='ms-3'>
											<h5>{(t('selection.videoPresentation'))}</h5>
											<h4 className='weight'>{videoSawPercent.toFixed(1)} %</h4>
										</div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					}
					<Col xs={12} md={data?.videoPresentation ? 4 : 6}>
						<Card>
							<Card.Body>
								<div className='d-flex align-items-center'>
									<div className='chartPreviewData'>
										<Doughnut
											data={{
												labels: [
													`${t('selection.interviewsDone')} (${interviewsDonePercent.toFixed(1)}%)`,
													`${t('selection.interviewsPending')} (${interviewsPendingPercentage.toFixed(1)}%)`
												],
												datasets: [
													{
														data: [
															data?.interviewsDoneCount || 0,
															data?.interviewsPendingCount || 0
														],
														backgroundColor: ['#89CF2B', '#DEF3BE'],
														hoverBackgroundColor: ['#89CF2BAA', '#DEF3BEAA'],
													},
												],
											}}
											options={options}
										/>
									</div>
									<div className='ms-3'>
										<h5>{(t('selection.interviewsDone'))}</h5>
										<h4 className='weight'>{interviewsDonePercent ? interviewsDonePercent?.toFixed(1) : 0} %</h4>
									</div>
								</div>
							</Card.Body>
						</Card>
					</Col>
					<Col xs={12} md={data?.videoPresentation ? 4 : 6}>
						<Card className='h-100'>
							<Card.Body className='d-flex align-items-center justify-content-center'>
								<div>
									<h5>{(t('selection.offerLetterSent'))}</h5>
									<h4 className='ms-2 weight'>{data.offerLetterSent}</h4>
								</div>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				<Row className='my-3 py-2 text-center'>
					<Col xs={6} md={3}>
						<Card>
							<Card.Body>
								{(t('selection.dataPreview.candidates'))}
								<h3>{data.chosenCount}</h3>
							</Card.Body>
						</Card>
					</Col>
					<Col xs={6} md={3}>
						<Card>
							<Card.Body>
								{(t('selection.dataPreview.archived'))}
								<h3>{data.archivedCount}</h3>
							</Card.Body>
						</Card>
					</Col>
					<Col xs={6} md={3}>
						<Card>
							<Card.Body>
								{(t('selection.dataPreview.refused'))}
								<h3>{data.refusedCount}</h3>
							</Card.Body>
						</Card>
					</Col>
					<Col xs={6} md={3}>
						<Card>
							<Card.Body>
								{t('selection.submenu.precandidates')}
								<h3>{data.precandidatesCount}</h3>
							</Card.Body>
						</Card>
					</Col>
				</Row>
            </Container>
        )
    }
	
	useEffect(() => {
		if(resultselection){
			switch (resultselection) {
				case 'successclone':
					Swal.fire({
						showConfirmButton: true,
						showDenyButton: false,
						confirmButtonText: t('selection.gotodraft'),
						icon: 'success',
						text: t('selection.successclone')
					}).then((result) => {
						if (result.isConfirmed) {
							navigate('/multischool/editprocess/' + selectionGoTo)
						}
					})
				default:
					break;
			}
		}
	// eslint-disable-next-line
	},[resultselection])

    return (
		<>
			<Container className='cuerpo'>
				<Row className='mb-4'>
					<Col className='d-flex align-items-center'>
						<img src="/images/menus/processes.svg" alt="Icono Procesos" width={24}/>
						<h1 className='ms-2 m-0'>{finished ? t('profile.school.endedprocess') : t('profile.school.activeprocess')}</h1>
					</Col>
				</Row>
                <Row className="mt-2">
					<Col>
						<Card className='mb-5 sombra'>
                            <Card.Body className='px-5 py-5 selection'>
								<Row>
									<Col xs={12} className='d-flex justify-content-between'>
										<h3>{finished ? t('profile.school.endedprocess') : t('profile.school.activeprocess')}</h3>
										{!finished &&
											<Link to='/multischool/programprocess' className='btn btn-primary'>
												<i className='fas fa-plus me-2'></i> {t('school.selection.newprocess')}
											</Link>
										}
									</Col>
								</Row>
								<Row>
									<Col>
									{selectionsFilter?.length > 0
										?
											<CustomDataTable
												columns={columnsSelections}
												data={selectionsFilter}
												defaultSortField="startDate"
												defaultSortAsc={true}
												expandedData={ExpandedRow}
											/>
										:
											<div className='text-center mt-5'>{t('selection.thereisnotprocess')}</div>
									}
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
            </Container>
        </>
    )
}